module.exports = __webpack_public_path__ + "img/ricelog_pinicon_103.2adb86f4.png";